const fetchSvg = (url: string, signal: any) => {
  return new Promise((resolve, reject) => {
    const executor = async () => {
      const request = new Request(url, {
        method: "GET",
        headers: {
          accept: "image/svg+xml",
        },
        credentials: "omit",
        signal,
        cache: "force-cache",
      });

      const cache = await caches?.open("svg-cache");
      const response = await cache?.match(request);

      const responseFunc = (response: Response, url: string) => {
        if (!response.ok) {
          reject(`Fetch svg failed. url=${response.url} status=${response.status} statusText=${response.statusText}`);
        }
        if (url.startsWith("data:")) {
          resolve(response.text()); // Directly resolve for data URLs without caching as it's not supported
        } else {
          // eslint-disable-next-line @typescript-eslint/no-floating-promises
          cache?.put(url, response.clone()).then(async () => {
            resolve(await response.text());
          });
        }
      };

      if (!response) {
        fetch(request, { signal: signal })
          .then((response) => {
            responseFunc(response, url);
          })
          .catch((error) => {
            // Don't log AbortError due to unmount as this i expected behaviour
            if (signal.aborted) {
              resolve(null);
            } else {
              reject(error);
            }
          });
      } else {
        responseFunc(response, url);
      }
    };
    if (url) {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      executor();
    } else {
      reject("Fetch svg aborted as url is not set");
    }
  });
};

export default fetchSvg;
